import {hideLoading, showLoading} from "../helpers/loading";
import {displayCompareBudgetsModal} from "../admin/temporary-budgets/compareBudgetsModal";
import {createModal} from "../helpers/modal";
import Axios from "axios";
import createElement from "../helpers/createElement";
import handleAjaxError from "../helpers/handleAjaxError";
import {getInputsByName} from "../helpers/forms";
import {waitUntil} from "../helpers/waitUntil";
import {scrollToElement} from "../helpers/scrolling/scrolling";

function initCustomerBudgetView() {
	const budgetSelect = document.querySelector('.budget-select-container select');
	if (budgetSelect) {
		budgetSelect.onchange = changeCurrentBudget;
	}

	const compareBudgetsButton = document.querySelector('.compare-budgets-button')
	if (compareBudgetsButton) {
		// noinspection JSUnresolvedVariable
		compareBudgetsButton.onclick = () => displayCompareBudgetsModal(window.budget);
	}

	const vendorPaymentModal = createModal({
		modalContainer: null,
		init() {
			if (!this.modalContainer.querySelector('.modal-body')) {
				// Not initialized
				return;
			}

			// Init selects
			[
				this.getCategorySelect(),
				this.getItemSelect(),
			].forEach(select => {
				select.addEventListener('change', handleModalUpdate)
			})
		},
		getCategorySelect() {
			return this.modalContainer.querySelector('select[name="category_id"]');
		},
		getItemSelect() {
			return this.modalContainer.querySelector('select[name="budget_item_id"]');
		}
	})

	// Init view payments button
	document.querySelectorAll('.view-vendor-payments-button').forEach(button => {
		button.addEventListener('click', () => displayViewVendorPaymentsModal(button.dataset.route))
	})


	// Focus an element if required

	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('f')) {
		focusTarget(urlParams.get('f'));
	}

	/**
	 * Methods
	 */

	function changeCurrentBudget() {
		const budgetId = budgetSelect.value;

		// noinspection JSUnresolvedVariable
		const url = window.viewBudgetGetRoute.replace('_BUDGET_', budgetId);

		showLoading();
		window.location.href = url;
	}

	function displayViewVendorPaymentsModal(paymentsUrl, inPlace = false) {
		showLoading()
		Axios.post(paymentsUrl)
			.then(response => {
				vendorPaymentModal.replace(
					createElement(response.data.modal, inPlace),
				);

				vendorPaymentModal.display(true);
			})
			.catch(handleAjaxError)
			.finally(hideLoading)
	}

	function handleModalUpdate() {
		showLoading();

		const data = {
			...getInputsByName(
				vendorPaymentModal.modalContainer,
				[
					'project_id',
					'budget_id',
					'category_id',
					'budget_item_id',
				])
		}

		// If modal already initialized, use route from modal, if not, use initial route
		// noinspection JSUnresolvedVariable
		const modalRefreshRoute = getInputsByName(vendorPaymentModal.modalContainer, ['refreshRoute']).refreshRoute;

		return Axios.post(modalRefreshRoute, data)
			.then(response => {
				vendorPaymentModal.replace(createElement(response.data.modal), true);
			})
			.catch(error => {
				handleAjaxError(error);
				// Hide modal if created
				vendorPaymentModal.hide()
			})
			.finally(stopLoading)
	}

	/**
	 * @param {string} target
	 */
	function focusTarget(target) {
		const progressSummaryEntryTargets = [
			'total spent',
			'total customer payments',
			'customer cash amount',
		];

		// Check if we are targeting a summary entry
		if (progressSummaryEntryTargets.includes(target)) {
			waitUntil(
				() => {
					return document.querySelector(`.summary-entry[data-key="${target}"]`);
				},
				{
					timeoutAfter: 10000,
				}
			).then(() => {
				const element = document.querySelector(`.summary-entry[data-key="${target}"]`)

				focusElement(element)
			})
		}
	}

	/**
	 * @param {HTMLElement} element
	 */
	function focusElement(element) {
		// Scroll to element
		waitUntil(() => {
			return document.hidden === false;
		}).then(() => {
			scrollToElement(element)
		})

		// Add highlight class
		element.classList.add('highlight');
	}
}


export {
	initCustomerBudgetView
}
